module.exports = __webpack_public_path__ + "img/icon_banner.a8606ccf.png";